import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Configuration from '../config';

const SCRIPT_ID = 'apple-sign-in-sdk';

const AppleSignIn = ({onAuthorization, label, className}) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!Configuration.appleClientId || !Configuration.appleRedirectUri) return undefined;
    const initialize = () => {
      if (!window.AppleID) return;
      window.AppleID.auth.init({
        clientId: Configuration.appleClientId,
        scope: 'name email',
        redirectURI: Configuration.appleRedirectUri,
        usePopup: true
      });
      setReady(true);
    };
    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/it_IT/appleid.auth.js';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
    script.addEventListener('load', initialize);
    if (window.AppleID) initialize();
    return () => script.removeEventListener('load', initialize);
  }, []);

  const signIn = async () => {
    try {
      const response = await window.AppleID.auth.signIn();
      if (response && response.authorization && response.authorization.code) {
        onAuthorization({code: response.authorization.code, user: response.user || null});
      }
    } catch (error) {
      if (!error || error.error !== 'popup_closed_by_user') console.error('Apple sign-in failed', error);
    }
  };

  if (!Configuration.appleClientId || !Configuration.appleRedirectUri) return null;
  return (
    <button type="button" className={`apple-sign-in-button ${className}`.trim()} disabled={!ready} onClick={signIn}>
      <span className="apple-sign-in-logo">&#63743;</span>
      {label}
    </button>
  );
};

AppleSignIn.propTypes = {onAuthorization: PropTypes.func.isRequired, label: PropTypes.string, className: PropTypes.string};
AppleSignIn.defaultProps = {label: 'Continua con Apple', className: ''};
export default AppleSignIn;
